export const views = {
  LANDING: 'LANDING',
  SELECT_THEME: 'SELECT_THEME',
  GAME: 'GAME',
  CONFIGURE: 'CONFIGURE',
  AWAIT_PAIRING: 'AWAIT_PAIRING',
  JOIN_GAME: 'JOIN_GAME',
};
